export const API_AUTH = {
	login: '/api/login',
	register: '/api/register',
	resetPassword: '/api/reset-password',
	changePassword: '/api/reset-password/change-password',
	forgottenPassword: '/api/reset-password/forgotten-password',
	verify: '/api/register/confirm',
	refreshToken: '/api/login/refresh-token',
};

export const API_INVITE = {
	invite: '/api/invitation/generate',
	getAll: '/api/invitation/get-all',
	approveByManager: '/api/invitation/approve-by-manager',
};

export const API_USER = {
	details: '/api/user',
	tasks: '/api/user/tasks',
	profile: '/api/user/profile',
	experience: '/api/user/experience',
	update: '/api/user/update-details',
	contactInfo: '/api/user/contact-info',
	onboarding: '/api/user/onboarding',
	managerOnboarding: '/api/user/manager-onboarding',
	managerOnboardingNeeded: '/api/user/manager-onboarding-needed',
	anexa6Preview: '/api/user/anexa6-preview',
	documents: '/api/user/documents',
	documentById: '/api/user/document',
	teamPendingSignatures: '/api/user/team-pending-signatures',
	managerSignDocuments: '/api/user/manager-sign-documents',
	anexa1SigningStatus: '/api/user/anexa1-signing-status',
	anexa1Preview: '/api/user/anexa1-preview',
	managerSignAnexa1: '/api/user/manager-sign-anexa1',
	notificationPreferences: '/api/user/notification-preferences',
};

export const API_DISCIPLINARY = {
	root: '/api/disciplinary',
	editDisciplinary: '/api/disciplinary/edit-disciplinary',
	history: '/api/disciplinary/history',
	nearSuspension: '/api/disciplinary/near-suspension',
	legacySuspensions: '/api/disciplinary/legacy-suspensions',
	managerDisciplinaryCards: '/api/manager-disciplinary/cards',
	managerDisciplinarySuspends: '/api/manager-disciplinary/suspends',
	managerDisciplinaryDashboard: '/api/manager-disciplinary/dashboard-summary',
};

export const API_USER_ADMINISTRATION = {
	all: '/api/administration/user/get-all',
	search: '/api/administration/user/search',
	contacts: '/api/administration/user/export-contacts',
	happyBirthdays: '/api/administration/user/happy-birthdays',
	sendHappyBirthdays: '/api/administration/user/send-happy-birthday-message',
	update: '/api/administration/user/update',
	updateIdentityCard: '/api/administration/user/update-identity-card',
	delete: '/api/administration/user/delete-user',
	addTaxAmount: '/api/administration/user/add-tax-amount',
	sendNotificationToManagers: '/api/administration/user/send-notification-managers',
	removeFromTeams: '/api/administration/user/remove-from-teams',
	getIdentityCard: '/api/administration/user/get-identity-card',
	disabledSuspend: '/api/administration/user/disabled-suspend',
	checkRiskAssessment: '/api/administration/user/check-risk-assessment',
	checkFitForSport: '/api/administration/user/check-fit-for-sport',
	approve: '/api/administration/user/approve',
	newPlayersSummary: '/api/administration/user/new-players-summary',
	taskHistories: '/api/administration/user/task-histories',
	signedDocuments: '/api/administration/user/signed-documents',
	pendingEmailChange: '/api/administration/user/pending-email-change',
	requestEmailChange: '/api/administration/user/request-email-change',
	confirmEmailChange: '/api/administration/user/confirm-email-change',
};

export const API_REVIEW = {
	addReviewConfig: '/api/review/add',
	addReviewRatings: '/api/review/add-review-ratings',
	allReviewConfig: '/api/review/all',
	allByCategory: '/api/review/all-by-category',
	updateReviewConfig: '/api/review/update',
	reviewRatingsAdded: '/api/review/reviews-added',
	reviewsForAdmin: '/api/review/reviews-for-admin',
	matchNegativeReviews: '/api/review/match-negative-reviews',
	teams: '/api/review/teams',
	players: '/api/review/players',
	approveReview: '/api/review/approve-review',
	deleteReview: '/api/review/delete-review',
	staffLastMatchForManager: '/api/review/staff-last-match-for-manager',
	staffReviewsAddedByManager: '/api/review/staff-reviews-added-by-manager',
};

export const API_NEWSLETTER = {
	all: '/api/newsletter/all',
	updateNewsletterList: '/api/newsletter/update-newsletter-list',
	deactivateNewsletter: '/api/newsletter/deactivate',
	exportEmails: '/api/newsletter/export-emails',
	sendNotification: '/api/newsletter/send-notification',
};

export const API_ANALYTIC = {
	usersAnalytic: '/api/analytics/user',
	countUsersEnabled: '/api/analytics/count-users-enabled',
	teamsAnalytic: '/api/analytics/teams',
	leagueStatistics: '/api/analytics/league-statistics',
	financialStatistics: '/api/analytics/financial-statistics',
	userFinancialStatistics: '/api/analytics/user-financial',
	totalIncome: '/api/analytics/total-income',
	perplexityTokens: '/api/analytics/perplexity',
};

export const API_TEAM = {
	add: '/api/football-team/create-team',
	edit: '/api/football-team/edit-team',
	yourTeams: '/api/football-team/get-teams',
	missions: '/api/football-team/missions',
	teamsByLeague: '/api/football-team/get-teams-by-league',
	nameOfTeams: '/api/football-team/name-of-teams',
	yourTeamsForInvite: '/api/football-team/get-teams-for-invite',
	getInvitedPlayers: '/api/football-team/get-invited-players/',
	getPlayers: '/api/football-team/get-players',
	getPlayersForTransfer: '/api/football-team/get-players-for-transfer',
	addPlayer: '/api/football-team/add-player',
	addPlayerByAdmin: '/api/football-team/add-player-by-admin',
	updateProfile: '/api/football-team/update-profile',
	addOfficial: '/api/football-team/add-official',
	removePlayers: '/api/football-team/remove-players',
	teamsForInterview: '/api/football-team/get-teams-for-filter',
	signedAnexa1CurrentEdition: '/api/football-team/signed-anexa1-current-edition',
};

export const API_TEAM_ADMINISTRATION = {
	all: '/api/football-team-administration/get-all',
	allByPlayer: '/api/football-team-administration/get-teams-by-player',
	update: '/api/football-team-administration/update-by-admin',
	changeManager: '/api/football-team-administration/change-manager',
	managersWithoutTeam: '/api/football-team-administration/managers-without-team',
	getTeamsForLeague: '/api/football-team-administration/get-teams-for-league',
	getTeamsForFilter: '/api/football-team-administration/get-teams-for-filter',
	overdueTax: '/api/football-team-administration/overdue-tax',
	blockTeam: '/api/football-team-administration/block-team',
	promptAiChronic: '/api/football-team-administration/prompt-ai-chronic',
	taskHistories: '/api/football-team-administration/task-histories',
	anexa1Statuses: '/api/football-team-administration/anexa1-statuses',
	teamDocuments: '/api/football-team-administration/team-documents',
	anexa1Status: '/api/football-team-administration/anexa1-status',
	sendAnexa1Reminder: '/api/football-team-administration/send-anexa1-reminder',
	sustainTeamReceipts: '/api/football-team-administration/sustain-team-receipts',
	summary: '/api/football-team-administration/summary',
	approve: '/api/football-team-administration/approve',
	overview: '/api/football-team-administration/overview',
};

export const API_COMPETITION = {
	all: '/api/competitions',
	update: '/api/competitions/update',
};

export const API_EDITIONS = {
	all: '/api/competitions/editions',
	allEditions: '/api/competitions/editions/all',
	currentEditions: '/api/competitions/editions/current-editions',
	update: '/api/competitions/editions/update',
	closeRetry: (editionUuid: string) => `/api/competitions/editions/${editionUuid}/close/retry`,
	closeMarkResolved: (editionUuid: string) =>
		`/api/competitions/editions/${editionUuid}/close/mark-resolved`,
};

export const API_LEAGUES = {
	all: '/api/competitions/editions/leagues',
	allByCompetitionUuid: '/api/competitions/editions/leagues/by-competition',
	add: '/api/competitions/editions/leagues/add-team',
	update: '/api/competitions/editions/leagues/update',
	sequenceTeam: '/api/competitions/editions/leagues/sequence-teams',
	getSequenceNumber: '/api/competitions/editions/leagues/sequence-number',
	generateTournament: '/api/competitions/editions/leagues/stages/generate-stages-matches',
	previewMatches: '/api/competitions/editions/leagues/stages/preview-matches',
	getStageNumbers: '/api/competitions/editions/leagues/stages/stage-numbers',
	getPrefilteredStagesAndMatches: '/api/competitions/editions/leagues/stages/prefiltered',
};

export const API_CUP = {
	all: '/api/competitions/editions/cup-administration/all',
	add: '/api/competitions/editions/cup-administration/add',
	edit: '/api/competitions/editions/cup-administration/edit',
	getToursByUuid: '/api/competitions/editions/cup-administration/get-tours',
	getAllTours: '/api/competitions/editions/cup-administration/get-all-tours',
	generateMatches: '/api/competitions/editions/cup-administration/generate-matches-ranking',
	addTour: '/api/competitions/editions/cup-administration/add-tour',
	editTour: '/api/competitions/editions/cup-administration/edit-tour',
	getAllTeamsNotInTour: '/api/competitions/editions/cup-administration/get-teams-for-tour',
	getAllTeamsInTour: '/api/competitions/editions/cup-administration/get-teams-in-tour',
	addTeamToTour: '/api/competitions/editions/cup-administration/add-team-to-tour',
	deleteTeamFromTour: '/api/competitions/editions/cup-administration/delete-team-from-tour',
	endGroupStage: '/api/competitions/editions/cup-administration/end-group-stage',
};

export const API_FIELDS = {
	all: '/api/fields/all',
	add: '/api/fields/add',
	edit: '/api/fields/edit',
	delete: '/api/fields/delete',
};

export const API_MATCH_HOURS = {
	all: '/api/match-hours/all',
	add: '/api/match-hours/add',
	delete: '/api/match-hours/delete',
};

export const API_LEAGUE_TAG = {
	all: '/api/tag-league/all',
	add: '/api/tag-league/add',
	edit: '/api/tag-league/edit',
	disableTag: '/api/tag-league/disable-tag',
};

export const API_BAR_ARTICLES = {
	all: '/api/bar-articles/all',
	add: '/api/bar-articles/add',
	edit: '/api/bar-articles/edit',
	delete: '/api/bar-articles/delete',
	toggleMenu: '/api/bar-articles/toggle-menu',
	clearMenu: '/api/bar-articles/clear-menu',
};

export const API_STAFF = {
	all: '/api/staff-matches/all',
	add: '/api/staff-matches/add',
	edit: '/api/staff-matches/edit',
	reviews: '/api/staff-matches/reviews',
};

export const API_MATCH = {
	scheduleMatch: '/api/matches/schedule',
	cancelMatch: '/api/matches/cancel',
	allScheduledMatches: '/api/matches/all-scheduled-matches',
	mediaLinks: '/api/matches/add-media-links',
	cloudLink: '/api/matches/add-cloud-link',
	changeStatus: '/api/matches/status-match',
	getscheduledMatch: '/api/matches/scheduled-match',
	getScore: '/api/matches/score-by-match',
	getYoutubeVideos: '/api/matches/photo-videos',
	addMatchToCupTour: '/api/matches/add-match-to-cup',
	cupMatches: '/api/matches/cup-matches',
	addStaff: '/api/matches/add-staff',
	updateStaff: '/api/matches/update-staff',
	getStaff: '/api/matches/get-staff',
	inQueueMatches: '/api/matches/in-queue-matches',
	countInQueueMatches: '/api/matches/count-in-queue-matches',
	publicInQueueMatches: '/api/matches/public-in-queue-matches',
	penaltyPhase: '/api/matches/penalty-phase',
	disciplinaryRerun: (matchUuid: string) => `/api/matches/${matchUuid}/disciplinary/rerun`,
	disciplinaryMarkResolved: (matchUuid: string) =>
		`/api/matches/${matchUuid}/disciplinary/mark-resolved`,
};

export const API_MATCH_EVENT = {
	root: '/api/matches/event',
	add: '/api/matches/event/add-event',
	editGoal: '/api/matches/event/edit-goal',
	changeStatus: '/api/matches/status-match',
	penaltyPhaseScore: '/api/matches/event/penalty-phase-score',
};

export const API_MATCH_STATISTICS = {
	add: '/api/match-statistics/add',
	edit: '/api/match-statistics/edit',
	getByMatchAndTeam: '/api/match-statistics/get-by-match-and-team',
};

export const API_MATCH_DETAIL_PLAYER = {
	all: '/api/match-detail-player/all-matches-team',
};

export const API_LINEUP = {
	getByMatch: '/api/lineup/get-by-match',
	getPlayers: '/api/lineup/get-players-by-team',
	getPlayersLineup: '/api/lineup/lineup-get-players',
	add: '/api/lineup/create',
	update: '/api/lineup/update',
	addUpdateLineupNumber: '/api/lineup/add-update-lineup-number',
};

export const API_FINANCIAL = {
	allTax: '/api/financial/all-tax',
	taxSelected: '/api/financial/tax-selected',
	allCredits: '/api/financial/all-credits',
	allTaxUser: '/api/user-financial/all',
	teamReport: '/api/user-financial/team-report',
	allManagers: '/api/financial/all-managers',
	allExpenses: '/api/financial/all-expenses',
	distinctFootballTeams: '/api/financial/distinct-football-teams',
	distinctManagers: '/api/financial/distinct-managers',
	addTax: '/api/financial/add',
	deleteTax: '/api/financial/delete',
	updateTax: '/api/financial/update',
	addCredits: '/api/financial/add-credits',
	addExpense: '/api/financial/add-expense',
	collectTax: '/api/financial/collect-tax',
	collectMultiTax: '/api/financial/collect-multiselect-tax',
	deleteExpense: '/api/financial/delete-expense',
	updateExpense: '/api/financial/update-expense',
	matchTax: '/api/financial/match-tax',
	overdueTax: '/api/financial/overdue-tax',
	overdueTeamTaxes: '/api/financial/overdue-team-tax',
	checkUniqueIdentifier: '/api/user-financial/check-unique-identifier',
	exportOverdueTeamTaxes: '/api/financial/export-overdue-team-tax',
};

export const API_COLLECTION_SHEET = {
	teams: '/api/collection-sheet/teams',
	teamDetails: '/api/collection-sheet/team-details',
	initiate: '/api/collection-sheet/initiate',
	status: '/api/collection-sheet/status',
	cancel: '/api/collection-sheet/cancel',
	confirmDetails: '/api/collection-sheet/confirm/details',
	confirmSubmit: '/api/collection-sheet/confirm/submit',
	all: '/api/collection-sheet/all',
	total: '/api/collection-sheet/total',
	export: '/api/collection-sheet/export',
	verify: '/api/collection-sheet/verify',
	delete: '/api/collection-sheet/delete',
	taxBreakdown: '/api/collection-sheet/tax-breakdown',
	report: '/api/collection-sheet/report',
	reportMonthly: '/api/collection-sheet/report-monthly',
};

export const API_FINANCIAL_HISTORY = {
	creditHistory: '/api/payments-history/credits',
	taxHistory: '/api/payments-history/tax',
};

export const API_NEWS = {
	all: '/api/news/all',
	allMarquee: '/api/news/marquee',
	add: '/api/news/add',
	addMarquee: '/api/news/marquee/add',
	editMarquee: '/api/news/marquee/edit',
	generateNews: '/api/news/generate-news',
	update: '/api/news/update',
	delete: '/api/news/delete',
};

export const API_INTERVIEWS = {
	all: '/api/interviews/all',
	add: '/api/interviews/add',
	edit: '/api/interviews/update',
	delete: '/api/interviews/delete',
};

export const API_CHRONIC = {
	all: '/api/chronic/all',
	add: '/api/chronic/add-chronic',
	generateChronic: '/api/chronic/generate-chronic',
	update: '/api/chronic/update-chronic',
};

export const API_RANKING = {
	getByLeague: '/api/ranking/get-by-league',
	getByCupTour: '/api/ranking/get-by-cupTour',
	teamSubmission: '/api/ranking/team-submission',
};

export const API_GENERAL_SETTINGS = {
	allSettings: '/api/general-settings/all-settings',
	addUpdate: '/api/general-settings/add-update',
	updateSigningSettings: '/api/general-settings/update-signing-settings',
	updateDisciplinarySettings: '/api/general-settings/update-disciplinary-settings',
	transferMarketBudget: '/api/general-settings/transfer-market-budget',
	transferMarketCampaignPreview: '/api/general-settings/transfer-market-campaign/preview',
	transferMarketCampaignApply: '/api/general-settings/transfer-market-campaign/apply',
	transferMarketCampaignExport: '/api/general-settings/transfer-market-campaign/export',
	updateSustainTeamAlertSettings: '/api/general-settings/update-sustain-team-alert-settings',
	sustainTeamWallSettings: '/api/general-settings/sustain-team-wall-settings',
	updateSustainTeamWallSettings: '/api/general-settings/update-sustain-team-wall-settings',
	previewSustainTeamSplash: '/api/general-settings/preview-sustain-team-splash',
	sustainTeamAdSettings: '/api/general-settings/sustain-team-ad-settings',
	updateSustainTeamAdSettings: '/api/general-settings/update-sustain-team-ad-settings',
	uploadAnexa6Template: '/api/general-settings/upload-anexa6-template',
	uploadAnexa1Template: '/api/general-settings/upload-anexa1-template',
};

export const API_S3_INTEGRATION_SETTINGS = {
	getSettings: '/api/general-settings/s3-integration',
	saveSettings: '/api/general-settings/s3-integration',
	runNow: '/api/general-settings/s3-integration/run-now',
	history: '/api/general-settings/s3-integration/history',
	pendingCount: '/api/general-settings/s3-integration/pending-count',
};

export const API_PERPLEXITY_SETTINGS = {
	allSettings: '/api/perplexity-settings/all-settings',
	addOrUpdate: '/api/perplexity-settings/add-update',
};

export const API_TRANSFER = {
	allTransfer: '/api/transfer/all-transfers',
	requestTransfer: '/api/transfer',
	requestTransferNoTeam: '/api/transfer/no-team',
	requestedByManager: '/api/transfer/requested-by-manager',
	requiresManagerApproval: '/api/transfer/requires-manager-approval',
	approveTransferByManager: '/api/transfer/approve-transfer-by-manager',
	approveTransferByAdmin: '/api/transfer/approve-transfer-by-admin',
	deleteTransfer: '/api/transfer/delete-transfer',
	noTeam: '/api/transfer/no-team',
	noTeamAdminView: '/api/transfer/no-team-admin-view',
	addTransferMarket: '/api/transfer/add-transfer-market',
	addPlayerTransferMarket: '/api/transfer/add-player-transfer-market',
	updateTransferMarket: '/api/transfer/update-transfer-market',
	allTransferMarketsByManager: '/api/transfer/transfer-markets',
	allTransferMarketsByPlayer: '/api/transfer/player-transfer-markets',
	deleteTransferMarket: '/api/transfer/delete-ad',
};

// Transfer market 2.0 (citiri publice: /api/landing-page/transfer-market/v2, actiuni: /api/transfer-market)
export const API_TRANSFER_MARKET = {
	summary: '/api/landing-page/transfer-market/v2/summary',
	formingTeams: '/api/landing-page/transfer-market/v2/forming-teams',
	teamAds: '/api/landing-page/transfer-market/v2/team-ads',
	transferPlayers: '/api/landing-page/transfer-market/v2/transfer-players',
	freePlayers: '/api/landing-page/transfer-market/v2/free-players',
	players: '/api/landing-page/transfer-market/v2/players',
	newPlayers: '/api/landing-page/transfer-market/v2/new-players',
	me: '/api/transfer-market/me',
	managerRequest: '/api/transfer-market/manager-request',
	createFormingTeam: '/api/transfer-market/forming-teams',
	formingTeam: '/api/transfer-market/forming-teams',
	requests: '/api/transfer-market/requests',
	myRequests: '/api/transfer-market/requests/mine',
	applications: '/api/transfer-market/applications',
	myTeamAds: '/api/transfer-market/team-ads/mine',
	teamAd: '/api/transfer-market/team-ads',
	seeking: '/api/transfer-market/seeking',
	invitations: '/api/transfer-market/invitations',
	emailQuota: '/api/transfer-market/invitations/email-quota',
	receivedInvitations: '/api/transfer-market/invitations/received',
	sentInvitations: '/api/transfer-market/invitations/sent',
	contact: '/api/transfer-market/contact',
	newPlayerReport: '/api/transfer-market/new-players',
	moderation: '/api/transfer-market-administration/moderation',
	managerRequests: '/api/transfer-market-administration/manager-requests',
	hideNewPlayer: '/api/transfer-market-administration/new-players',
};

export const API_PARTNERS = {
	addCategory: '/api/partners/add-category',
	editCategory: '/api/partners/edit-category',
	allCategory: '/api/partners/all-category',
	allPartners: '/api/partners/all-partners',
	allPartnersAward: '/api/partners/all-partners-award',
	addPartner: '/api/partners/add-partner',
	editPartner: '/api/partners/edit-partner',
	disablePartner: '/api/partners/disable-partner',
};

export const API_AWARD = {
	all: '/api/awards/all',
	add: '/api/awards/add',
	addArticle: '/api/awards/add-article',
	editArticle: '/api/awards/edit-article',
	landingPage: '/api/awards/landing-page',
	addToLandingPage: '/api/awards/add-to-landing-page',
	editLandingPage: '/api/awards/edit-landing-page',
	article: '/api/awards/article',
	edit: '/api/awards/edit',
};

export const API_FAQ = {
	allCategory: '/api/faq/all-categories',
	allFaqs: '/api/faq/all-faqs',
	addCategory: '/api/faq/add-category',
	editCategory: '/api/faq/edit-category',
	addFaq: '/api/faq/add-faq',
	editFaq: '/api/faq/edit-faq',
	deleteFaq: '/api/faq/delete-faq',
};

export const API_MARKETPLACE = {
	addProductCategory: '/api/marketplace/add-product-category',
	addProduct: '/api/marketplace/add-product',
	addOrder: '/api/marketplace/add-order',
	orders: '/api/marketplace/orders',
	userOrders: '/api/marketplace/user-orders',
	updateProduct: '/api/marketplace/update-product',
	updateOrder: '/api/marketplace/update-order',
	updateProductCategory: '/api/marketplace/update-product-category',
	allCategories: '/api/marketplace/all-categories',
	allProducts: '/api/marketplace/all-products',
	productsShop: '/api/marketplace/products-shop',
};

export const API_MENU = {
	all: '/api/menus/all',
	add: '/api/menus/add',
	edit: '/api/menus/edit',
	addMenuItem: '/api/menus/add-menu-item',
	allMenuItems: '/api/menus/all-menu-items',
	allLeaguesAndCups: '/api/menus/all-leagues-and-cup',
};

export const API_EDITION_JOURNAL = {
	all: '/api/edition-journal/all',
	statistics: '/api/edition-journal/statistics',
	add: '/api/edition-journal/add',
	edit: '/api/edition-journal/edit',
	allByManager: '/api/edition-journal/all/manager',
	confirm: '/api/edition-journal/confirm',
	editions: '/api/edition-journal/editions',
	delete: '/api/edition-journal/delete',
	byTeam: '/api/edition-journal/by-team',
};

export const API_LANDING_PAGE_SETTINGS = {
	add: '/api/landing-page-settings/add-legend-page',
	edit: '/api/landing-page-settings/edit-legend-page',
	legendPage: '/api/landing-page-settings/legend-page',
};

export const API_LEGEND = {
	all: '/api/legend/all',
	add: '/api/legend/add',
	edit: '/api/legend/edit',
	delete: '/api/legend/delete',
};

export const API_WINNER_TEAM = {
	all: '/api/winner-team/all',
	add: '/api/winner-team/add',
	edit: '/api/winner-team/edit',
	delete: '/api/winner-team/delete-team',
};

export const API_EDITION_JOURNAL_PLAYER = {
	findPlayers: '/api/edition-journal-player/search-players',
	addPlayer: '/api/edition-journal-player/add-player',
	playersAdded: '/api/edition-journal-player/players-added',
	allPlayersAdded: '/api/edition-journal-player/all-players-added',
	confirmationsOnTeam: '/api/edition-journal-player/confirmations-on-team',
	confirm: '/api/edition-journal-player/confirm',
	confirmByAdmin: '/api/edition-journal-player/confirm-by-admin',
	delete: '/api/edition-journal-player/delete',
	editions: '/api/edition-journal-player/editions',
};

export const API_SUSTAIN_TEAM = {
	myTeams: '/api/sustain-team/my-teams',
	progress: '/api/sustain-team/progress',
	upload: '/api/sustain-team/upload',
	delete: '/api/sustain-team/delete',
};

export const API_ADMIN_REGENERATE = {
	single: (id: number) => `/api/admin/regenerate-documents/${id}`,
	all: '/api/admin/regenerate-documents',
};

export const API_DOCS_ADMIN = {
	all: '/api/docs-administration/all',
	allForWizard: '/api/docs-administration/all-for-wizard',
	allForUsers: '/api/docs-administration/doc-users',
	add: '/api/docs-administration/add',
	edit: '/api/docs-administration/edit',
};

export const API_VIMEO = {
	upload: '/api/vimeo/upload',
	uploadBulk: '/api/vimeo/upload/bulk',
	delete: '/api/vimeo/delete',
};

export const API_COMMERCIAL_VIDEOS = {
	all: '/api/commercial-videos',
	nowPlaying: '/api/commercial-videos/now-playing',
	uploadVimeo: '/api/commercial-videos/upload-vimeo',
	addYoutube: '/api/commercial-videos/add-youtube',
	update: (uuid: string) => `/api/commercial-videos/${uuid}`,
	reorder: '/api/commercial-videos/reorder',
	delete: (uuid: string) => `/api/commercial-videos/${uuid}`,
	cast: (uuid: string) => `/api/commercial-videos/${uuid}/cast`,
};

export const API_BROADCAST = {
	all: '/api/broadcast',
	add: '/api/broadcast/add-channel',
	edit: '/api/broadcast/edit-channel',
};

export const API_MISSION = {
	addTaskConfig: '/api/task-mission/add-task-config',
	updateTaskConfig: '/api/task-mission/edit-task-config',
	playerAllTaskConfigs: '/api/task-mission/player-all-task-configs',
	teamAllTaskConfigs: '/api/task-mission/team-all-task-configs',
	taskPointUsers: '/api/task-mission/task-point-users-ranking',
};

export const API_NOTIFICATIONS = {
	all: '/api/notifications',
	unreadCount: '/api/notifications/unread-count',
	markRead: '/api/notifications/mark-read',
};

export const API_COMPANY = {
	getBookKeeping: '/api/company/all-book-keeping',
	getUserCompanies: '/api/company/user',
	getBarCompany: '/api/company/bar',
	add: '/api/company/add',
	edit: '/api/company/edit',
	remove: '/api/company/remove',
	associateTeam: '/api/company/associate-team',
	removeTeam: '/api/company/remove-team',
};

export const API_CRM = {
	// Setari generale -> Acces CRM / Integrari CRM (super admin)
	accessUsers: '/api/crm/access/users',
	integrations: '/api/crm/integrations',
	regenerateClickphoneToken: '/api/crm/integrations/clickphone/regenerate-token',
	webhookLog: '/api/crm/integrations/webhook-log',
	me: '/api/crm/me',
	editions: '/api/crm/editions',
	edition: (uuid: string) => `/api/crm/editions/${uuid}`,
	editionAction: (uuid: string, action: 'open' | 'pause' | 'playing' | 'close' | 'reopen') =>
		`/api/crm/editions/${uuid}/${action}`,
	editionCards: '/api/crm/editions/cards',
	editionMovable: (uuid: string) => `/api/crm/editions/${uuid}/movable`,
	editionMove: (uuid: string) => `/api/crm/editions/${uuid}/move`,
	config: '/api/crm/config',
	features: '/api/crm/features',
	leads: '/api/crm/leads',
	lead: (uuid: string) => `/api/crm/leads/${uuid}`,
	leadDuplicates: '/api/crm/leads/duplicates',
	leadAction: (
		uuid: string,
		action: 'take' | 'release' | 'put-back' | 'call-start' | 'call-end' | 'outcome' | 'phase2',
	) => `/api/crm/leads/${uuid}/${action}`,
	leadContact: (uuid: string, kind: 'MAIL' | 'WHATSAPP' | 'SMS_REQUEST' | 'SENT') =>
		`/api/crm/leads/${uuid}/contact/${kind}`,
	leadPhase3: (uuid: string) => `/api/crm/leads/${uuid}/phase3`,
	leadPhase2Pass: (uuid: string, toUuid: string) =>
		`/api/crm/leads/${uuid}/phase2/pass/${toUuid}`,
	phase2Targets: '/api/crm/phase2-targets',
	leadAssignees: (uuid: string) => `/api/crm/leads/${uuid}/assignees`,
	leadAssign: (uuid: string, userUuid: string) => `/api/crm/leads/${uuid}/assign/${userUuid}`,
	leadCalls: (uuid: string) => `/api/crm/leads/${uuid}/calls`,
	leadCallTranscript: (uuid: string, callId: number) =>
		`/api/crm/leads/${uuid}/calls/${callId}/transcript`,
	leadSigned: (uuid: string, step?: 'confirm' | 'reject') =>
		`/api/crm/leads/${uuid}/signed${step ? `/${step}` : ''}`,
	signups: '/api/crm/signups',
	signup: (uuid: string) => `/api/crm/signups/${uuid}`,
	signupContract: (uuid: string) => `/api/crm/signups/${uuid}/contract`,
	signupTeamOptions: '/api/crm/signups/team-options',
	syncTeams: '/api/crm/sync/teams',
	importList: '/api/crm/import',
	importGoogleSheet: '/api/crm/import/google-sheet',
	smsOverview: '/api/crm/sms/overview',
	smsCredit: '/api/crm/sms/credit',
	smsDraft: (uuid: string) => `/api/crm/sms/draft/${uuid}`,
	smsSend: (uuid: string) => `/api/crm/sms/send/${uuid}`,
	smsRefuse: (uuid: string) => `/api/crm/sms/refuse/${uuid}`,
	smsSendAll: '/api/crm/sms/send-all',
	smsListPreview: '/api/crm/sms/list/preview',
	smsListSend: '/api/crm/sms/list/send',
	smsListRefresh: (listId: string) => `/api/crm/sms/list/${listId}/refresh`,
	pendingPlayerEmails: '/api/crm/players/pending-emails',
	mailDraft: (uuid: string) => `/api/crm/mail/draft/${uuid}`,
	mailSend: (uuid: string) => `/api/crm/mail/send/${uuid}`,
	mailStats: '/api/crm/mail/stats',
	settings: '/api/crm/settings',
	settingsResetTexts: '/api/crm/settings/reset-texts',
	settingsSmsPoolReset: '/api/crm/settings/sms-pool/reset',
	rollover: '/api/crm/rollover',
	reports: '/api/crm/reports',
	reportsExport: '/api/crm/reports/export',
	reportPerson: (userUuid: string) => `/api/crm/reports/person/${userUuid}`,
	reportsAdCost: '/api/crm/reports/ad-cost',
	reportMessages: '/api/crm/reports/messages',
	reportMessageList: '/api/crm/reports/messages/list',
};
